/*======================================
===============for live use=============*/
// export const environment = {
//   production: false,
//   apiUrl:'https://fd.fareboutique.com/',
//   url : 'https://fd.fareboutique.com/',
//   imageurl:'https://fd.fareboutique.com/uploads/userprofile/',
//   airlineurl:'https://fd.fareboutique.com/uploads/airlines/',
//   title: 'Supplier',
//   xkey: '1AKUO11640863661272',
//   adminPath:'',
//   firebase: {
//     apiKey: "AIzaSyCYD9XULCFhZ85ITW2I_pH67ZxQG0Lh-6A",
//     authDomain: "angularnoti-5224a.firebaseapp.com",
//     projectId: "angularnoti-5224a",
//     storageBucket: "angularnoti-5224a.appspot.com",
//     messagingSenderId: "1015037219900",
//     appId: "1:1015037219900:web:ed895e3899d80ec256df39",
//     measurementId: "G-T1JKFBCXQ5",
//     vapidKey: 'BB0DjFt-0d_n8Pg3aEPnGjn3NRAkFrEzAAP7tQl0xLHZUbo9joPkvXmazhQUcRDIrkdxK3DlHS988deNwevgg6Y'
//   },
//   /* if we build for client use main domain change adminPath "/admin"
//    otherwise blank adminPath use for localhost //and online use other domain change according to your folder path*/
// };

/*======================================
===============for dev/local use=============*/

export const environment = {
  production: false,
  apiUrl: 'https://local.flightapi.co.in/v1/',
  url: 'https://local.flightapi.co.in/',
  imageurl: 'https://local.flightapi.co.in/uploads/userprofile/',
  airlineurl: 'https://local.flightapi.co.in/uploads/airlines/',

  // apiUrl: 'https://testpackage.fdking.com/flights/v1/',
  // url: 'https://testpackage.fdking.com/flights/',
  // imageurl: 'https://testpackage.fdking.com/flights/uploads/userprofile/',
  // airlineurl: 'https://testpackage.fdking.com/flights/uploads/airlines/',

  // apiUrl: 'https://api.bookingwindow.com/flights/v1/',
  // url: 'https://api.bookingwindow.com/flights/',
  // imageurl: 'https://api.bookingwindow.com/flights/uploads/userprofile/',
  // airlineurl: 'https://api.bookingwindow.com/flights/uploads/airlines/',
  adminPath: '',
  title: 'Supplier',
  // xkey: '1FMQKB1639407126571',
  key: '2PBP7IABZ2',
  salt: 'DAH88E3UWQ',
  firebase: {
    apiKey: "AIzaSyCYD9XULCFhZ85ITW2I_pH67ZxQG0Lh-6A",
    authDomain: "angularnoti-5224a.firebaseapp.com",
    projectId: "angularnoti-5224a",
    storageBucket: "angularnoti-5224a.appspot.com",
    messagingSenderId: "1015037219900",
    appId: "1:1015037219900:web:ed895e3899d80ec256df39",
    measurementId: "G-T1JKFBCXQ5",
    vapidKey: 'BB0DjFt-0d_n8Pg3aEPnGjn3NRAkFrEzAAP7tQl0xLHZUbo9joPkvXmazhQUcRDIrkdxK3DlHS988deNwevgg6Y'
  },
  // apiUrl: 'https://devapi.fareboutique.com/v1/',
  //adminPath:'/fareboutique_demo',
  /*if we build for client use main domain change adminPath "/admin" */
  /* otherwise blank adminPath use for localhost //and online use other domain change according to your folder path*/
};

/*======================================*/

// export const environment = {
//   production: true,
//   apiUrl: 'https://fd.fareboutique.com/',
//   url: 'https://fd.fareboutique.com/',
//   imageurl: 'https://fd.fareboutique.com/uploads/userprofile/',
//   airlineurl: 'https://fd.fareboutique.com/uploads/airlines/',
//   // apiUrl:'https://api.bookingwindow.com/flights/',
//   // url : 'https://api.bookingwindow.com/flights/',
//   // imageurl:'https://api.bookingwindow.com/flights/uploads/userprofile/',
//   // airlineurl:'https://api.bookingwindow.com/flights/uploads/airlines/',
//   title: 'Supplier',
//   adminPath: '',
//   // xkey: '1AKUO11640863661272',
//   // if we build for client use main domain change adminPath "/admin"
//   // otherwise blank adminPath use for localhost //and online use other domain change according to your folder path
//   firebase: {
//     apiKey: "AIzaSyCYD9XULCFhZ85ITW2I_pH67ZxQG0Lh-6A",
//     authDomain: "angularnoti-5224a.firebaseapp.com",
//     projectId: "angularnoti-5224a",
//     storageBucket: "angularnoti-5224a.appspot.com",
//     messagingSenderId: "1015037219900",
//     appId: "1:1015037219900:web:ed895e3899d80ec256df39",
//     measurementId: "G-T1JKFBCXQ5",
//     vapidKey: 'BB0DjFt-0d_n8Pg3aEPnGjn3NRAkFrEzAAP7tQl0xLHZUbo9joPkvXmazhQUcRDIrkdxK3DlHS988deNwevgg6Y'
//   }
// };